module.exports = __webpack_public_path__ + "static/media/champagne_glasses.c6e91bed.svg";